import { render } from "./DeepPriceAnalysisLink.vue?vue&type=template&id=b799224c&scoped=true"
import script from "./DeepPriceAnalysisLink.vue?vue&type=script&lang=js"
export * from "./DeepPriceAnalysisLink.vue?vue&type=script&lang=js"

import "./DeepPriceAnalysisLink.vue?vue&type=style&index=0&id=b799224c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b799224c"]])

export default __exports__